// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3pBHG","header":"ClearentDisclaimer_header__3iNDt","inner":"ClearentDisclaimer_inner__1Bftz"};